import { Group, Loader, Text, Tooltip } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';
import { useEffect, useState } from 'react';

export function AutoRefreshIndicator({
  lastFetchedAt,
  isFetching,
  intervalMs,
}: {
  lastFetchedAt: number;
  isFetching: boolean;
  intervalMs: number;
}) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const remainingMs = Math.max(0, intervalMs - (now - lastFetchedAt));
  const remainingSec = Math.ceil(remainingMs / 1000);
  const label = isFetching
    ? 'Refreshing now…'
    : lastFetchedAt === 0
      ? `Refreshes every ${Math.round(intervalMs / 1000)}s`
      : `Refreshes in ${remainingSec}s`;

  return (
    <Tooltip
      label={`Auto-refreshes every ${Math.round(intervalMs / 1000)}s while this tab is focused.`}
      withArrow
    >
      <Group gap={6} c="dimmed" wrap="nowrap" role="status" aria-live="polite">
        {isFetching ? <Loader size={12} /> : <IconRefresh size={14} />}
        <Text size="xs">{label}</Text>
      </Group>
    </Tooltip>
  );
}
